import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-playlists',
  templateUrl: './playlists.component.html',
  styleUrls: ['./playlists.component.css']
})
export class AdminPlaylistsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
